import React from 'react';
import { MarketActionCard, MarketRow } from '@market/react';
import { subtitleStrings } from 'utilities/financing_strings';
import { useTranslation } from 'react-i18next';
import { toCurrency } from 'utilities/currency';

const Offer = (props) => {
  const { o, showSubtitle, disabled } = props;
  const { t } = useTranslation();
  const paymentAmount = o.payment_amount;
  const subtitles = subtitleStrings(o);
  return (
    <MarketActionCard value={o.token} {...(disabled && { disabled: true })}>
      <MarketRow>
        <label slot="label">
          {t('checkout.receipt.label.nPayments', {
            n: o.number_payment_periods,
          })}
        </label>
        {showSubtitle &&
          subtitles.map((s, idx) => (
            <React.Fragment key={`offer-subtitle-${idx}`}>
              <p slot="subtext">{s}</p>
            </React.Fragment>
          ))}
        <label slot="side-label">
          {t('checkout.payment_option.tagline', {
            amountString: toCurrency(
              paymentAmount.amount,
              paymentAmount.currency,
            ),
            period: o.number_payment_periods - 1,
          })}
        </label>
      </MarketRow>
    </MarketActionCard>
  );
};

export default Offer;
